/**
 * device barrel — Phase 5.2 public surface.
 *
 * Consumers import from `@serviceme/devtools-core/device` (subpath
 * added in `package.json` `exports` map). The subpath keeps the
 * device namespace from colliding with the Phase 5b auth/toolbox
 * siblings at the type level.
 *
 * Refs:
 * - 4.功能规划.md §2.2 — `device/index.ts`
 */

export { DeviceCore, type DeviceCoreOptions } from "./DeviceCore";
export {
	type BuildSignedHeadersParams,
	buildSignedHeaders,
	createDeviceRequestSignature,
	DeviceAuthHeaders,
	type DeviceRequestSignatureParams,
	type DeviceSignedHeaders,
} from "./deviceAuth";
export {
	DeviceReenrollRequiresAuthError,
	DeviceSecretVersionMismatchError,
	Enroller,
	type EnrollerOptions,
	type EnrollRequestFn,
	type EnrollResponse,
} from "./Enroller";
export {
	FsIdentityFileBackend,
	type IdentityFileBackend,
	IdentityStore,
	type IdentityStoreOptions,
} from "./IdentityStore";
export {
	deriveInstallationId,
	fingerprintSource,
	randomInstallationId,
} from "./InstallationId";
export {
	type AtomicWriteResult,
	DEVICE_JSON_SCHEMA_VERSION,
	type IdentityStoreHooks,
	type PersistedDeviceIdentity,
} from "./types";
